export function ensureOriginInString(url: string, newOrigin: string): string {
    const hadTrailingSlash = url.endsWith("/");
    const urlObj = new URL(url, newOrigin);
    if (urlObj.origin !== newOrigin) {
        urlObj.host = new URL(newOrigin).host;
    }
    const result = urlObj.toString();
    if (!hadTrailingSlash && result.endsWith("/")) {
        return result.slice(0, -1);
    }
    return result;
}

export function ensureOriginInRequest(request: Request, newOrigin: string): Request {
    return {
        ...request,
        url: ensureOriginInString(request.url, newOrigin),
    };
}
